__turbopack_context__.v({
  "card": "AiInRecruitingIntegrationSection-module__raiEPq__card",
  "cardLabel": "AiInRecruitingIntegrationSection-module__raiEPq__cardLabel",
  "cardText": "AiInRecruitingIntegrationSection-module__raiEPq__cardText",
  "integrationSection": "AiInRecruitingIntegrationSection-module__raiEPq__integrationSection",
  "list": "AiInRecruitingIntegrationSection-module__raiEPq__list",
  "numberCircle": "AiInRecruitingIntegrationSection-module__raiEPq__numberCircle",
  "sectionSubtitle": "AiInRecruitingIntegrationSection-module__raiEPq__sectionSubtitle",
  "sectionTitle": "AiInRecruitingIntegrationSection-module__raiEPq__sectionTitle",
});
